// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__26c8z","row":"ProcedureTreatmentSummary_row__1olMe"};